import { Container } from '@/components/container'
import { Footer } from '@/components/footer'
import { MeetingWasteCalculator } from '@/components/meeting-waste/meeting-waste-calculator'
import { MeetingWasteSeo } from '@/components/meeting-waste/meeting-waste-seo'
import { Navbar } from '@/components/navbar'
import { Head } from '@inertiajs/react'

const TITLE = 'Wasted Money Meeting Calculator'
const DESCRIPTION =
  'Free wasted money meeting calculator. Salary, attendees, and duration show the annual standup tax. Replace status meetings with GitHub digests.'

export default function MeetingWasteShow() {
  return (
    <>
      <Head title={TITLE}>
        <meta head-key="description" name="description" content={DESCRIPTION} />
      </Head>
      <div className="flex min-h-screen flex-col">
        <main className="flex-1 overflow-hidden">
          <Container>
            <Navbar />
          </Container>
          <div className="from-background via-feature-subtle/50 to-muted/20 min-h-100vh bg-gradient-to-b">
            <Container className="py-16 md:py-24">
              <MeetingWasteCalculator />
              <MeetingWasteSeo />
            </Container>
          </div>
        </main>
        <Footer />
      </div>
    </>
  )
}
